export const flexBaseUrl = import.meta.env.VITE_FLEX_API_URL;
export const springBaseUrl = import.meta.env.VITE_SPRING_API_URL;
export const reachBaseUrl = import.meta.env.VITE_REACH_API_URL;
